import { BookOpen } from "lucide-react";

const books = [
  {
    title: "The Passion Centered Person",
    tagline: "How to Go From Having Just a Career to Having a Life",
    desc: "Gary's signature work — co-authored with Tim Vandehey and endorsed by Mark Victor Hansen (Chicken Soup for the Soul): \"You are a WOW of a WOW!\" On rediscovering the internal fuel that helps people rise, adjust, reconnect, and keep moving forward.",
    accent: "#EC1985",
    cover: "/images/book-passion-centered.png",
  },
  {
    title: "Whispers from the Master",
    tagline: "The Language of God · 52-Week Leadership Study to a Deeper Purpose",
    desc: "A 52-week leadership devotional drawn from decades of leadership, loss, faith, and renewal — a quiet companion for the leader who wants to lead from a deeper place.",
    accent: "#FFFFFF",
    cover: "/images/book-whispers-from-the-master.webp",
  },
];

export default function Books() {
  return (
    <section id="books" data-testid="books-section" className="bg-[#050505] py-24 md:py-32 border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="section-num">05 / PUBLICATIONS</span>
          <div className="divider-red" />
        </div>
        <h2 className="h-display text-5xl md:text-6xl lg:text-7xl mb-4 max-w-4xl">
          Books that <span className="text-[#EC1985]">jumpstart</span><br />the people who read them.
        </h2>
        <p className="max-w-xl text-white/70 text-lg">
          Three titles built from 40+ years of platform experience, leadership, and lived resilience.
        </p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl">
          {books.map((b, idx) => (
            <article
              key={b.title}
              data-testid={`book-${idx}`}
              className="surface p-8 flex flex-col hover:border-[#EC1985] transition-colors group"
            >
              {/* Book cover */}
              {b.cover ? (
                <div className="aspect-[2/3] w-full mb-6 relative overflow-hidden border border-[#262626] bg-[#0a0a0a]">
                  <img
                    src={b.cover}
                    alt={`${b.title} book cover`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ) : (
                <div
                  className="aspect-[2/3] w-full mb-6 relative overflow-hidden flex flex-col justify-between p-6"
                  style={{
                    background:
                      idx % 2 === 0
                        ? "linear-gradient(180deg, #1a1a1a 0%, #0a0a0a 100%)"
                        : "linear-gradient(180deg, #EC1985 0%, #7a0e4a 100%)",
                    border: "1px solid #262626",
                  }}
                >
                  <BookOpen
                    size={28}
                    style={{ color: b.accent }}
                    className="opacity-90"
                  />
                  <div>
                    <div
                      className="font-display text-2xl leading-tight"
                      style={{ color: idx % 2 === 0 ? b.accent : "#fff" }}
                    >
                      {b.title}
                    </div>
                    <div className="mt-3 text-[10px] uppercase tracking-[0.3em] text-white/70 font-bold">
                      by Gary Zelesky
                    </div>
                  </div>
                </div>
              )}
              <h3 className="font-display text-2xl text-white">{b.title}</h3>
              <div className="mt-1 text-xs uppercase tracking-[0.2em] text-[#EC1985] font-bold">
                {b.tagline}
              </div>
              <p className="mt-4 text-white/70 leading-relaxed text-sm flex-1">{b.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
